// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restore-form-container {
	background: var(--white);
	border-radius: 10px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	width: 100%;
	max-width: 500px;
	padding: 30px;
	text-align: center;
}

.restore-title {
	font-size: 30px;
	margin-bottom: 10px;
}

.error {
	color: var(--danger-color);
	font-size: 20px;
	text-align: center;
	font-weight: 600;
	margin: 0;
}

.restore-form-group {
	width: 100%;
	margin-bottom: 20px;
	text-align: right;
}

.restore-label {
	font-size: 22px;
	margin-bottom: 8px;
}

.restore-input {
	height: 50px;

	border-radius: 5px;
}

.restore-button {
	background-color: var(--primary-color);
	width: 120px;
	padding: 10px 20px;
	font-size: 20px;
	font-weight: 500;
}

@media (max-width: 480px) {
	.restore-form-container {
		padding: 20px;
	}

	.restore-title {
		font-size: 26px;
	}

	.restore-button {
		width: 100%;
		padding: 10px;
		font-size: 20px;
	}

	.restore-form-group {
		width: 100%;
	}

	.restore-label {
		font-size: 20px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/SendOTP/SendOTP.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,mBAAmB;CACnB,wCAAwC;CACxC,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,YAAY;;CAEZ,kBAAkB;AACnB;;AAEA;CACC,sCAAsC;CACtC,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,aAAa;EACb,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".restore-form-container {\n\tbackground: var(--white);\n\tborder-radius: 10px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\twidth: 100%;\n\tmax-width: 500px;\n\tpadding: 30px;\n\ttext-align: center;\n}\n\n.restore-title {\n\tfont-size: 30px;\n\tmargin-bottom: 10px;\n}\n\n.error {\n\tcolor: var(--danger-color);\n\tfont-size: 20px;\n\ttext-align: center;\n\tfont-weight: 600;\n\tmargin: 0;\n}\n\n.restore-form-group {\n\twidth: 100%;\n\tmargin-bottom: 20px;\n\ttext-align: right;\n}\n\n.restore-label {\n\tfont-size: 22px;\n\tmargin-bottom: 8px;\n}\n\n.restore-input {\n\theight: 50px;\n\n\tborder-radius: 5px;\n}\n\n.restore-button {\n\tbackground-color: var(--primary-color);\n\twidth: 120px;\n\tpadding: 10px 20px;\n\tfont-size: 20px;\n\tfont-weight: 500;\n}\n\n@media (max-width: 480px) {\n\t.restore-form-container {\n\t\tpadding: 20px;\n\t}\n\n\t.restore-title {\n\t\tfont-size: 26px;\n\t}\n\n\t.restore-button {\n\t\twidth: 100%;\n\t\tpadding: 10px;\n\t\tfont-size: 20px;\n\t}\n\n\t.restore-form-group {\n\t\twidth: 100%;\n\t}\n\n\t.restore-label {\n\t\tfont-size: 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
